import { ApiService } from "@core/api/api-service";
import { addMasterUrlInterceptor } from "@core/api/interceptors/add-master-url-interceptor";
import { errorHandlingInterceptor } from "@core/api/interceptors/error-handling-interceptor";
import { addRequestInterceptor, addResponseInterceptor } from "@core/api/interceptors/interceptor";
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export class MasterApiService implements ApiService {
	constructor(readonly axiosInstance: AxiosInstance) {
		addRequestInterceptor(this.axiosInstance, addMasterUrlInterceptor);

		addResponseInterceptor(this.axiosInstance, errorHandlingInterceptor());
	}

	get<T = unknown, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.get(url, config);
	}

	post<T = unknown, R = AxiosResponse<T>>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.post(url, data, config);
	}

	put<T = unknown, R = AxiosResponse<T>>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.put(url, data, config);
	}

	delete<T = unknown, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.delete(url, config);
	}
}
